<template>
    <DCard
        padding
    >
        <DRow
            class="ms-2 mb-2"
            align-vertical="end"
        >
            <DCol sm="2">
                <DInput
                    id="name"
                    v-model="form.name"
                    :label="__('users.index.name')"
                    class="mb-0"
                    type="text"
                    @keydown.enter.exact.prevent="changePage(1)"
                />
            </DCol>
            <DCol sm="2">
                <DInput
                    id="date-to"
                    v-model="form.email"
                    :label="__('users.index.email')"
                    class="mb-0"
                    type="text"
                    @keydown.enter.exact.prevent="changePage(1)"
                />
            </DCol>
            <DCol sm="2">
                <DSelect
                    id="role-dropdown"
                    v-model="form.role"
                    :label="__('users.index.table.role')"
                    :options="roles"
                />
            </DCol>
            <DCol sm="1">
                <DSwitch
                    id="disabled-users-switch"
                    v-model="form.disabled"
                    :label="__('users.index.disabled_users')"
                    variant="3d"
                    @update:checked="changeStatusFilter"
                />
            </DCol>
            <DCol
                sm="2"
                class="d-flex gap-2"
            >
                <DButton
                    id="filter-apply"
                    :label="__('tools.invoices.filters.filter')"
                    @click="changePage(1)"
                />
                <DButton
                    id="filter-reset"
                    icon="filter-off"
                    :label="__('messages.actions.reset_filter')"
                    @click="resetFilters"
                />
            </DCol>
        </DRow>
        <DTable
            v-model:column-filter-value="columnFilters"
            v-model:table-filter-value="tableFilters"
            :items="users.data"
            :fields="[
                {key: 'id', label: __('users.index.table.id'), _classes: 'id'},
                {key: 'name', label: __('users.index.table.name'), _classes: 'name'},
                {key: 'email', label: __('users.index.table.email'), _classes: 'email'},
                {key: 'role', label: __('users.index.table.role'), _classes: 'role'},
                {key: 'disabled', label: __('users.index.table.status'), _classes: 'disabled'},
                {key: 'updated_at', label: __('users.index.table.updated_at'), filter: false, _classes: 'last-login'},
                {key: 'actions', label: '', filter: false, _classes: ''},
            ]"
            hover
        >
            <template #name="{item}">
                <td v-if="item.display_name">
                    {{ item.display_name }}({{ item.name }})
                </td>
                <td v-else>
                    {{ item.name }}
                </td>
            </template>
            <template #updated_at="{item}">
                <td> {{ setDateFormat(item.updated_at) }}</td>
            </template>

            <template #role="{item}">
                <td> {{ item.role === null ? '' : item.role }}</td>
            </template>
            <template #disabled="{item}">
                <td> {{ item.disabled ? __('users.index.table.inactive') : __('users.index.table.active') }}</td>
            </template>
            <template #actions="{item}">
                <td>
                    <DDropdown
                        toggler-text="..."
                        add-menu-classes="pt-0 pb-0"
                        :size="'sm'"
                        color="secondary"
                        placement="bottom"
                    >
                        <DDropdownItem
                            @click="changeStatus(item)"
                        >
                            <span>{{ item.disabled ? __('users.index.enable') : __('users.index.disable') }}</span>
                        </DDropdownItem>
                        <DDropdownItem
                            v-if="canEdit(item)"
                            @click="editUser(item)"
                        >
                            <span>{{ __('users.index.edit') }}</span>
                        </DDropdownItem>
                    </DDropdown>
                </td>
            </template>
        </DTable>
        <DPagination
            v-if="users.last_page > 1"
            class="pb-2"
            :active-page="users.current_page"
            :pages="users.last_page"
            align="center"
            @update:activePage="changePage"
        />

        <DFabs>
            <DFab
                v-if="userPermissions.includes('user.create')"
                id="btn-add"
                icon="plus"
                :label="__('users.index.add_user')"
                @click="showCreateUserModal"
            />
        </DFabs>

        <CreateUserModal
            v-if="createUserModalVisible && userPermissions.includes('user.create')"
            :show-modal="createUserModalVisible"
            :roles="roles"
            :errors="errors"
            is-confirm
            @close-modal="createUserModalVisible = false"
        />
    </DCard>
</template>

<script>
import CreateUserModal from '~@/Components/Users/Users/CreateUserModal'
export default {
    name: 'UserIndex',
    components: {
        CreateUserModal
    },
    props: {
        users: {
            type: Object,
            default: () => { return {} }
        },
        roles: {
            type: Object,
            default: () => { return {} }
        },
        filters: {
            type: Object,
            default: () => { return {} }
        },
        errors: {
            type: Object,
            default () {
                return {}
            }
        }
    },
    data () {
        return {
            columnFilters: {},
            tableFilters: '',
            createUserModalVisible: false,
            form: this.$inertia.form({
                name: this.filters.name ?? null,
                role: this.filters.role ?? null,
                email: this.filters.email ?? null,
                disabled: this.filters.disabled ?? false
            })
        }
    },
    computed: {
        userPermissions () {
            return this.$page.props.auth.permissions
        }
    },
    methods: {
        changeStatusFilter () {
            this.form.disabled = !this.form.disabled
        },
        changePage (page) {
            this.$inertia.get(this.$route('users.index', {
                disabled: this.form.disabled,
                name: this.form.name,
                role: this.form.role,
                email: this.form.email,
                save_filters: true
            }), {
                page: page
            })
        },
        changeStatus (item) {
            this.$inertia.post(this.$route('users.change-status', {
                user: item.id
            }))
        },
        resetFilters () {
            this.$inertia.get(this.$route('users.index', {
                save_filters: true,
                default_filters: true
            }))
        },
        showCreateUserModal () {
            this.createUserModalVisible = true
        },
        canEdit (item) {
            return this.$page.props.auth.permissions.includes('user.edit_local') && item.local
        },
        editUser (item) {
            this.$inertia.get(this.$route('users.edit', {
                user: item.id
            }))
        }
    }
}
</script>
